import React from "react";

import axios from "axios";
import { Routes, Route } from "react-router-dom";

import WebRoutes from "./routes/frontend/WebRoutes";

import AdminRoutes from "./routes/admin/AdminRoutes";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = "application/json";
axios.defaults.withCredentials = true;

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("auth_token");
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

function App() {
  return (
    <Routes>
        <Route path="*" element={<WebRoutes />} />
        <Route path="admin/*" element={<AdminRoutes />} />
    </Routes>
  );
}

export default App;
